import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../redux/actions/index';
import { Icon, ICONS } from 'components/Icons';
import ContactComponent from './ContactComponent';

import './contactButton.scss';

function ContactButton({ user, authenticated, actions }) {
  // Declare a new state variable, which we'll call "count"
  const [isOpen, setIsOpen] = useState(false);

  if (!isOpen) {
    return (
      <div className="contact-button">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(true);
          }}
          type="button"
        >
          <span className="text">Help</span>
          <Icon icon={ICONS.ARROW_UP} />
        </button>
      </div>
    );
  }

  return (
    <div className="contact-pane">
      <ContactComponent
        showClose
        onClose={() => {
          setIsOpen(false);
        }}
        user={user}
        authenticated={authenticated}
        actions={actions}
        isContactPage={false}
      />
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  const user = state.user.user;

  return {
    user,
    authenticated: state.user.authenticated,
  };
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactButton);
